/**
 * CalculateListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  TabMenu,
  Information,
  ModalLayout,
  Statistic,
} from 'components';
import { Button, DatePicker, Input, Select, Radio, Calendar, Tag } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const CalculateListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [viewType, setViewType] = useState('list');
  const [clickDate, setClickDate] = useState(null);
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'출금완료'}>출금완료</Radio>
                <Radio value={'출금예정'}>출금예정</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '날짜',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '프로모션',
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder="프로모션을 선택해주세요"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="검색어를 입력해주세요"
              style={{ ...styles.form.input.large, width: 400 }}
            />
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  // for (let i = 0; i < 3; i++) {
  //   newData.push({
  //     주문번호: '0000000',
  //     상태: '결제완료',
  //     메뉴명: '카페라테 외 3건',
  //     결제일: new Date(),
  //     결제수단: '카드',
  //     결제금액: 20000,
  //     수수료: 2000,
  //     구매자: '홍길동',
  //     정산: i > 0 ? '정산예정' : '정산완료',
  //     url: 'https://www.naver.com',
  //   });
  // }

  let tabItems = [];
  // for (let i = 0; i < 9; i++) {
  //   tabItems.push({
  //     key: `${i}`,
  //     label: i === 0 ? '전체' : `커피점 ${i}`,
  //   });
  // }

  /* ===== FUNCTION ===== */
  const handleDayClick = ({ $d }) => {
    setClickDate($d);
    setIsDrawerOpened(!isDrawerOpened);
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>정산내역</Title>

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 20,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            <Row>
              <Col x={24}>
                <Content
                  maxWidth={'100%'}
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <h2
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#404040',
                      lineHeight: '133%',
                    }}
                  >
                    정산내역
                  </h2>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 25,
                      fontWeight: 700,
                    }}
                  >
                    <button
                      style={{
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: 25,
                        fontWeight: 700,
                      }}
                    >
                      <LeftOutlined />
                    </button>
                    <span style={{ padding: '0px 10px' }}>
                      {moment().format('YYYY년 MM월')}
                    </span>
                    <button
                      style={{
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: 25,
                        fontWeight: 700,
                      }}
                    >
                      <RightOutlined />
                    </button>
                  </div>

                  <div>
                    <Button style={{ marginRight: 4 }}>정산메일발송</Button>
                    <Button style={{ marginRight: 4 }}>엑셀다운로드</Button>
                    <Button
                      type="primary"
                      style={{ background: 'var(--primary-color)' }}
                      onClick={() => setIsModalOpened(!isModalOpened)}
                    >
                      일괄정산
                    </Button>
                  </div>
                </Content>
              </Col>

              <Col x={24}>
                <Content maxWidth={'100%'} padding={10}>
                  <Information
                    content={[
                      '오늘 입금될 상품 결제대금과 과거 정산내역, 상품주문별 상세 정산내역을 확인하실 수 있습니다.',
                      '상품주문별 결제대금 및 수수료와 관련된 결제대금 정산, 할인/적립과 관련된 혜택정산, 상품 판매대금에 연계되지 못하고 적용되는 일별/공제 환급, 지급보류 금액을 확인하실 수 있습니다.',
                      '스마트스토어 판매 내역의 부가세신고를 돕기 위한 참고 자료를 확인하실 수 있습니다.',
                      '수수료내역(네이버페이 결제수수료, 네이버쇼핑 매출연동수수료, 무이자할부수수료,(구)판매수수료 등)에 대해 판매자에게 발행된 세금계산서 내역을 확인하실 수 있습니다.',
                    ]}
                  />
                </Content>

                <Content maxWidth={'100%'} padding={'0px 10px'}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      borderBottom: '1px solid #EBEBEB',
                      paddingBottom: 10,
                    }}
                  >
                    <h4
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#4A4A4A',
                      }}
                    >
                      이번달 정산 예정일: <span>25</span>일
                    </h4>
                    <div>
                      {[
                        { label: '목록', value: 'list' },
                        { label: '달력', value: 'calendar' },
                      ].map((_item, _index) => (
                        <Button
                          key={`button_${_index}`}
                          size="small"
                          style={{
                            marginLeft: 3,
                            borderColor:
                              _item.value === viewType
                                ? 'var(--primary-color)'
                                : 'rgba(112, 115, 124, 0.2)',
                            color:
                              _item.value === viewType
                                ? 'var(--primary-color)'
                                : '#171719',
                          }}
                          onClick={() => setViewType(_item.value)}
                        >
                          {_item.label}
                        </Button>
                      ))}
                    </div>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    {[
                      { label: '합계', value: 0 },
                      { label: '정산완료', value: 0 },
                      { label: '정산예정', value: 0 },
                    ].map((_item, _index) => (
                      <div
                        style={{
                          borderRight: '1px solid #EBEBEB',
                          width: '33%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <h4
                          style={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#4B4B4B',
                            paddingRight: 30,
                          }}
                        >
                          {_item.label}
                        </h4>
                        <p
                          style={{
                            fontSize: 24,
                            fontWeight: 400,
                            color: 'var(--black-color)',
                          }}
                        >
                          {stringToMoneyFormat(_item.value, '원')}
                        </p>
                      </div>
                    ))}
                  </div>

                  <Content maxWidth={'100%'} padding={'10px 0px'}>
                    {viewType === 'list' ? (
                      <Table
                        data={newData}
                        columns={[
                          {
                            title: '주문번호',
                            key: '주문번호',
                          },
                          {
                            title: '상태',
                            key: '상태',
                            render: (item) => <Tag color="green">{item}</Tag>,
                          },
                          {
                            title: '메뉴명',
                            key: '메뉴명',
                            width: 300,
                            render: (item, { url }) => (
                              <button
                                style={{
                                  border: 'none',
                                  background: 'none',
                                  textDecoration: 'underline',
                                  color: '#1C6BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {item}
                              </button>
                            ),
                          },
                          {
                            title: '결제일',
                            key: '결제일',
                            render: (item) =>
                              moment(item).format('YYYY-MM-DD (HH:mm:ss)'),
                          },
                          {
                            title: '결제수단',
                            key: '결제수단',
                          },
                          {
                            title: '결제금액',
                            key: '결제금액',
                            render: (item) => stringToMoneyFormat(item, '원'),
                          },
                          {
                            title: '수수료',
                            key: '수수료',
                            render: (item) => (
                              <p>[기본] {stringToMoneyFormat(item, '원')}</p>
                            ),
                          },
                          {
                            title: '구매자',
                            key: '구매자',
                            render: (item, { url }) => (
                              <button
                                style={{
                                  border: 'none',
                                  background: 'none',
                                  textDecoration: 'underline',
                                  color: '#1C6BFF',
                                  cursor: 'pointer',
                                }}
                              >
                                {item}
                              </button>
                            ),
                          },
                          {
                            title: '정산',
                            key: '정산',
                            render: (item) => (
                              <Tag
                                color={item === '정산완료' ? 'green' : 'gold'}
                              >
                                {item}
                              </Tag>
                            ),
                          },
                        ]}
                      />
                    ) : (
                      <Calendar
                        headerRender={() => {
                          return <></>;
                        }}
                        onSelect={(d) => handleDayClick(d)}
                      />
                    )}
                  </Content>
                </Content>
              </Col>
              {/* 정산내역 끝 */}
            </Row>
          </Col>
        </Row>
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={isModalOpened}
        onCancel={setIsModalOpened}
        centered
        closable
        title={`${moment(clickDate ?? new Date()).format('M월')} 일괄정산`}
        width={798}
      >
        <Content
          maxWidth={'100%'}
          padding={0}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              <Content
                maxWidth={'100%'}
                padding={10}
                style={{ display: 'flex', borderBottom: '1px solid #EBEBEB' }}
              >
                {[
                  { label: '합계', value: 18000000 },
                  { label: '정산완료', value: 12000000 },
                  { label: '정산예정', value: 6000000 },
                ].map((_item, _index) => (
                  <Statistic
                    title={_item.label}
                    value={stringToMoneyFormat(_item.value, '원')}
                    align="center"
                    titleStyle={{
                      fontSize: 22,
                      fontWeight: 700,
                      color: '#4B4B4B',
                    }}
                    valueStyle={{
                      fontSize: 27,
                      fontWeight: 400,
                      color: 'var(--black-color)',
                    }}
                  />
                ))}
              </Content>
            </Col>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={'5px 0px'}>
                <Information
                  content={[
                    '오늘 입금될 상품 결제대금과 과거 정산내역, 상품주문별 상세 정산내역을 확인하실 수 있습니다.',
                    '상품주문별 결제대금 및 수수료와 관련된 결제대금 정산, 할인/적립과 관련된 혜택정산, 상품 판매대금에 연계되지 못하고 적용되는 일별/공제 환급, 지급보류 금액을 확인하실 수 있습니다.',
                    '스마트스토어 판매 내역의 부가세신고를 돕기 위한 참고 자료를 확인하실 수 있습니다.',
                    '수수료내역(네이버페이 결제수수료, 네이버쇼핑 매출연동수수료, 무이자할부수수료,(구)판매수수료 등)에 대해 판매자에게 발행된 세금계산서 내역을 확인하실 수 있습니다.',
                  ]}
                />
              </Content>
            </Col>
            <Col x={8}>
              <Content maxWidth={'100%'} padding={5}>
                <TabMenu items={tabItems} suffix={'none'} />
              </Content>
            </Col>
            <Col x={16}>
              <Content maxWidth={'100%'} padding={5}>
                <Table
                  data={newData}
                  columns={[
                    {
                      title: '주문번호',
                      key: '주문번호',
                    },
                    {
                      title: '상태',
                      key: '상태',
                      render: (item) => <Tag color="green">{item}</Tag>,
                    },
                    {
                      title: '메뉴명',
                      key: '메뉴명',
                      width: 300,
                      render: (item, { url }) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '결제일',
                      key: '결제일',
                      render: (item) =>
                        moment(item).format('YYYY-MM-DD (HH:mm:ss)'),
                    },
                    {
                      title: '결제수단',
                      key: '결제수단',
                    },
                    {
                      title: '결제금액',
                      key: '결제금액',
                      render: (item) => stringToMoneyFormat(item, '원'),
                    },
                    {
                      title: '수수료',
                      key: '수수료',
                      render: (item) => (
                        <p>[기본] {stringToMoneyFormat(item, '원')}</p>
                      ),
                    },
                    {
                      title: '구매자',
                      key: '구매자',
                      render: (item, { url }) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '정산',
                      key: '정산',
                      render: (item) => (
                        <Tag color={item === '정산완료' ? 'green' : 'gold'}>
                          {item}
                        </Tag>
                      ),
                    },
                  ]}
                  minHeight={'auto'}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>

      {/* Drawer */}
      <ModalLayout
        type={'drawer'}
        open={isDrawerOpened}
        onCancel={setIsDrawerOpened}
        centered
        title={`${moment(clickDate).format('MM월 DD일')} 정산 상세내역`}
        width={'30%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={10}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <Button onClick={() => setIsDrawerOpened(false)}>닫기</Button>
            </div>
            <div>
              <Button style={{ marginRight: 8 }}>엑셀다운로드</Button>
              <Button
                type="primary"
                style={{ background: 'var(--primary-color)' }}
                onClick={() => {
                  setIsDrawerOpened(false);
                  setIsModalOpened(true);
                }}
              >
                일괄정산
              </Button>
            </div>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={0}>
          <Row>
            <Col x={24}>
              <Content
                maxWidth={'100%'}
                padding={0}
                style={{ display: 'flex' }}
              >
                {[
                  { label: '합계', value: 18000000 },
                  { label: '정산완료', value: 12000000 },
                  { label: '정산예정', value: 6000000 },
                ].map((_item, _index) => (
                  <Statistic
                    title={_item.label}
                    value={stringToMoneyFormat(_item.value, '원')}
                    align="center"
                    titleStyle={{
                      fontSize: 22,
                      fontWeight: 700,
                      color: '#4B4B4B',
                    }}
                    valueStyle={{
                      fontSize: 27,
                      fontWeight: 400,
                      color: 'var(--black-color)',
                    }}
                  />
                ))}
              </Content>

              <Content maxWidth={'100%'} padding={0} style={{ marginTop: 40 }}>
                <Table
                  data={newData}
                  columns={[
                    {
                      title: '주문번호',
                      key: '주문번호',
                    },
                    {
                      title: '상태',
                      key: '상태',
                      render: (item) => <Tag color="green">{item}</Tag>,
                    },
                    {
                      title: '메뉴명',
                      key: '메뉴명',
                      width: 300,
                      render: (item, { url }) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '결제일',
                      key: '결제일',
                      render: (item) =>
                        moment(item).format('YYYY-MM-DD (HH:mm:ss)'),
                    },
                    {
                      title: '결제수단',
                      key: '결제수단',
                    },
                    {
                      title: '결제금액',
                      key: '결제금액',
                      render: (item) => stringToMoneyFormat(item, '원'),
                    },
                    {
                      title: '수수료',
                      key: '수수료',
                      render: (item) => (
                        <p>[기본] {stringToMoneyFormat(item, '원')}</p>
                      ),
                    },
                    {
                      title: '구매자',
                      key: '구매자',
                      render: (item, { url }) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '정산',
                      key: '정산',
                      render: (item) => (
                        <Tag color={item === '정산완료' ? 'green' : 'gold'}>
                          {item}
                        </Tag>
                      ),
                    },
                  ]}
                  minHeight={'auto'}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default CalculateListPresenter;
